export default "__VITE_ASSET__NQDpE_HH__"